import psHttp from '@patsnap/common-ps-http';
import { emailAlertApiUrlPrefix, coreSearchApiUrlPrefix } from '../../config/constants';

export function emailSendApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/email/patent-sharing`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getAlertSettingApi() {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/setting`,
        method: 'GET',
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function setAlertSettingApi(data) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/setting`,
        method: 'PUT',
        data,
    }).then(({ data }) => {
        return data || {};
    });
}

export function searchAssignApi(keyword) {
    return psHttp({
        url: `${emailAlertApiUrlPrefix}/emailalert/alert/search/assignee`,
        method: 'GET',
        params: {
            keyword
        },
        transformCode: true
    });
}